import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {IonicModule} from '@ionic/angular';

import {PaymentSuccessPage} from './payment-success.page';
import {SharedModuleModule} from '../../shared-module/shared-module.module';
import {QRCodeModule} from 'angularx-qrcode';

const routes: Routes = [
	{
		path: '',
		component: PaymentSuccessPage
	}
];

@NgModule({
	imports: [CommonModule, FormsModule, IonicModule, RouterModule.forChild(routes), SharedModuleModule, QRCodeModule],
	declarations: [PaymentSuccessPage]
})
export class SuccessPageModule {}
